import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PageHeader from '../PageHeader';
import FeedTable from '../../containers/table/feed/FeedTable';
import PeriodFilter from '../../components/filter/PeriodFilter';

export default class InterestsPage extends Component {
    static propTypes = {
        // Props
        title: PropTypes.string.isRequired,
        filters: PropTypes.object.isRequired,
        symbols: PropTypes.array.isRequired,
        isFetching: PropTypes.bool.isRequired,

        // Dispatch
        changeFilters: PropTypes.func.isRequired,
        loadingInterests: PropTypes.func.isRequired,
    };

    render() {
        const { filters, isFetching, symbols, changeFilters, loadingInterests } = this.props;

        return (
            <div>
                <PageHeader title={this.props.title} />
                <PeriodFilter changeFilters={this.props.changeFilters} period={filters.period} />
                <FeedTable
                    symbols={symbols}
                    filters={filters}
                    changeFilters={changeFilters}
                    loading={loadingInterests}
                    isFetching={isFetching}
                />
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/components/pages/InterestsPage.js
 **/